import { render, staticRenderFns } from "./Enfold.vue?vue&type=template&id=904f5c18&scoped=true"
import script from "./Enfold.vue?vue&type=script&lang=js"
export * from "./Enfold.vue?vue&type=script&lang=js"
import style0 from "./Enfold.vue?vue&type=style&index=0&id=904f5c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904f5c18",
  null
  
)

export default component.exports